import { Disclosure, Menu } from "@headlessui/react";
import {
  Bars3Icon,
  XMarkIcon,
  ArrowUpRightIcon,
} from "@heroicons/react/24/outline";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { signInWithGoogle, signOut } from "../../apis/Signin";
import { getUser } from "../../services/Authservice";
import SearchBar from "./SearchBar";

const navigation = [
  ["Explore", "/"],
  ["My learning", "/dashboard"],
  ["Notes", "/notes"],
];

export default function Navbar() {
  const user = getUser();
  const name = user?.name?.givenName || user?.displayName || "Learner";
  const navigate = useNavigate();
  const search = (term) => navigate(`/search?q=${encodeURIComponent(term)}`);

  return (
    <Disclosure as="header" className="site-header">
      {({ open }) => (
        <>
          <a className="skip-link" href="#main-content">
            Skip to content
          </a>
          <div className="page-width nav-bar">
            <Link to="/" className="brand" aria-label="Saarthi home">
              saarthi<span>.</span>
            </Link>
            <nav className="desktop-nav" aria-label="Main navigation">
              {navigation.map(([label, to]) => (
                <NavLink key={to} to={to} end>
                  {label}
                </NavLink>
              ))}
            </nav>
            <div className="nav-search">
              <SearchBar handleFormSubmit={search} />
            </div>
            {user ? (
              <Menu as="div" className="profile-menu">
                <Menu.Button
                  className="avatar-button"
                  aria-label="Open account menu"
                >
                  {user.photos?.[0]?.value ? (
                    <img
                      src={user.photos[0].value}
                      alt=""
                      referrerPolicy="no-referrer"
                    />
                  ) : (
                    name[0]
                  )}
                </Menu.Button>
                <Menu.Items className="account-dropdown">
                  <p>Hi, {name}</p>
                  <Menu.Item>
                    {({ active }) => (
                      <Link className={active ? "active" : ""} to="/dashboard">
                        My learning
                      </Link>
                    )}
                  </Menu.Item>
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        className={active ? "active" : ""}
                        onClick={signOut}
                      >
                        Sign out
                      </button>
                    )}
                  </Menu.Item>
                </Menu.Items>
              </Menu>
            ) : (
              <button
                className="button button-primary nav-signin"
                onClick={signInWithGoogle}
              >
                Sign in <ArrowUpRightIcon />
              </button>
            )}
            <Disclosure.Button
              className="mobile-toggle"
              aria-label={open ? "Close menu" : "Open menu"}
            >
              {open ? <XMarkIcon /> : <Bars3Icon />}
            </Disclosure.Button>
          </div>
          <Disclosure.Panel className="mobile-nav page-width">
            <nav aria-label="Mobile navigation">
              {navigation.map(([label, to]) => (
                <Disclosure.Button as={NavLink} key={to} to={to} end>
                  {label}
                </Disclosure.Button>
              ))}
            </nav>
            <SearchBar handleFormSubmit={search} />
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
